<template>
    <section>
        <app-verse-detail :bookDetails="bookDetails"></app-verse-detail>
        <app-modal-buttons></app-modal-buttons>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-sm-6 col-md-3">
                            <!-- Book Modal -->
                            <app-modal v-if="bookModalVisible" @close="bookModalVisible = false" :payload="{oldTestBooks: oldTestBooks, newTestBooks: newTestBooks}">
                                <h4 slot="header">Select a book</h4>
                                <div slot="body" v-if="this.$store.getters.getOldTSelected">
                                    <template v-for="(oldTestBook, i) in oldTestBooks">
                                        <template v-if="oldTestBook.jesus">
                                            <a  
                                                :key="oldTestBook.bookname" 
                                                @click="updateBook(oldTestBook.bookname, i)"
                                                class="modal-item book">{{ oldTestBook.bookname }}</a> 
                                        </template>
                                    </template> 
                                </div>
                                <div slot="body" v-else>
                                    <template v-for="(newTestBook, i) in newTestBooks">
                                        <template v-if="newTestBook.jesus">
                                            <a  
                                                :key="newTestBook.bookname" 
                                                @click="updateBook(newTestBook.bookname, i)"
                                                class="modal-item book">{{ newTestBook.bookname }}</a> 
                                        </template>
                                    </template>     
                                </div>
                            </app-modal>
                            <div class="modalBtnCont">
                                <button id="show-modal" class="btn btn-selectBtn" @click="bookModalVisible = true">Book</button> {{ this.$store.getters.getOldTSelected ? oldTestamentBookName : newTestamentBookName }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <!-- Chapter Modal -->
                            <app-modal v-if="chapterModalVisible" @close="chapterModalVisible = false" :payload="{oldTestBooks: oldTestBooks, newTestBooks: newTestBooks}">
                                <h4 slot="header">Select a verse</h4>
                                <div slot="body" v-if="this.$store.getters.getOldTSelected">
                                    <a 
                                        v-for="(num, i) in oldTestBooks[oldTBookKey].jesusVerses"
                                        :key="i" 
                                        @click="updateJesusChapterAndVerse(num, 'oldTestament')"
                                        class="modal-item chapter">{{ num }}</a> 
                                </div>
                                <div slot="body" v-else>
                                    <a 
                                        v-for="(num, i) in newTestBooks[newTBookKey].jesusVerses"
                                        :key="i" 
                                        @click="updateJesusChapterAndVerse(num, 'newTestament')"
                                        class="modal-item chapter">{{ num }}</a> 
                                </div>
                            </app-modal>
                            <div class="modalBtnCont">
                                <button id="show-modal" class="btn btn-selectBtn" @click="chapterModalVisible = true">Verse</button> {{ this.$store.getters.getOldTSelected ? oldJesusChapterVerse : newJesusChapterVerse }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                            <div class="button-align">
                                <button class="btn btn-success" @click="fetchData('JustJesus')">View</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import VerseDetail from '../components/VerseDetail.vue';
    import { SearchVerse } from '../mixins/SearchVerseMixin';
    import { SaveVerse } from '../mixins/SaveVerseMixin';
    import ModalButtons from '../components/ModalButtons.vue';
    import Modal from '../components/UI/Modal.vue';

    export default {
        mixins: [SearchVerse, SaveVerse],
        data() {
            return {
                oldTBookKey: '22',
                newTBookKey: '0',
                oldJesusChapterVerse: '',
                newJesusChapterVerse: ''
            }
        },
        watch: {
            oldTestamentBookName() {
                this.oldJesusChapterVerse = this.oldTestBooks[this.oldTBookKey].jesusVerses[0];
            },
            newTestamentBookName() {
                this.newJesusChapterVerse = this.newTestBooks[this.newTBookKey].jesusVerses[0];
            }
        }, 
        components: {
            appVerseDetail: VerseDetail,
            appModalButtons: ModalButtons,
            appModal: Modal
        },
        created() {
            this.$store.dispatch('updateOldTestamentBookName','Isaiah');
            this.$store.dispatch('updateNewTestamentBookName','St.Matthew');
            this.$store.dispatch('updateCurrentPage','jesus');
            this.oldJesusChapterVerse = this.oldTestBooks[this.oldTBookKey].jesusVerses[0];
            this.newJesusChapterVerse = this.newTestBooks[this.newTBookKey].jesusVerses[0];
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/Jesus.vue